import {Controller} from "@/controllers/Controller";

/**
 * Controller for statistics API : every call takes the period query (?start=&end=&granularity=)
 */
export class StatisticsController extends Controller {

    static getOverview(urlParams) {
        return this.requestBuilder("GET", `/business/statistics/overview${urlParams}`, true);
    }

    static getClients(urlParams) {
        return this.requestBuilder("GET", `/business/statistics/clients${urlParams}`, true);
    }

    static getQuotes(urlParams) {
        return this.requestBuilder("GET", `/business/statistics/quotes${urlParams}`, true);
    }

    static getInvoices(urlParams) {
        return this.requestBuilder("GET", `/business/statistics/invoices${urlParams}`, true);
    }

    static getCollections(urlParams) {
        return this.requestBuilder("GET", `/business/statistics/collections${urlParams}`, true);
    }

}
